import React from "react";

interface ButtonCheckboxProps {
  checked: Boolean;
  disabled: Boolean;
  label?: string;
  onChange?: func;
  checkboxEnd: Boolean;
}

const ButtonCheckbox: React.FC<ButtonCheckboxProps> = ({ checked, disabled, label, onChange, checkboxEnd }) => {
  return (
    <small>
      {checkboxEnd && label}
      <input
        type="checkbox"
        className="mx-1"
        checked={checked}
        onChange={(v) => {
          onChange(v);
        }}
        disabled={disabled}
      />
      {!checkboxEnd && label}
    </small>
  );
};

export default ButtonCheckbox;
